module.exports = __webpack_public_path__ + "img/background-ball.8770b458.png";